import { useParams, Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import ClientView from '../components/ClientView';
import { getAudit, saveAudit } from '../utils/storage';
import { exportReportToPDF } from '../utils/export';

export default function Report() {
  const { auditId } = useParams();
  const [audit, setAudit] = useState(null);
  const [loading, setLoading] = useState(true);
  const [exporting, setExporting] = useState(false);

  useEffect(() => {
    getAudit(auditId).then(data => {
      setAudit(data);
      setLoading(false);
    });
  }, [auditId]);

  if (loading) return <div className="text-center py-20 text-neutral-500">Loading...</div>;
  if (!audit) return (
    <div className="text-center py-20">
      <p className="text-neutral-400">Audit not found.</p>
      <Link to="/dashboard" className="btn-primary mt-4 inline-block">Back to Dashboard</Link>
    </div>
  );

  const handleExport = async () => {
    setExporting(true);
    try {
      await exportReportToPDF('client-report', `WhatsNEXT-${audit.intake?.conceptName || 'Report'}.pdf`);
    } catch (err) { console.error('PDF export error:', err); }
    setExporting(false);
  };

  const handleSaveSections = async (sections) => {
    const updated = { ...audit, reportSections: sections };
    setAudit(updated);
    await saveAudit(updated);
  };

  return (
    <div>
      <div className="flex items-center gap-3 mb-6">
        <Link to={`/dashboard/${auditId}`} className="btn-ghost text-xs">← Dashboard</Link>
        <div className="flex-1" />
        <Link to={`/client/${auditId}`} className="btn-secondary text-xs py-2">Client Link</Link>
        <button onClick={handleExport} disabled={exporting} className="btn-primary text-xs py-2 disabled:opacity-50">
          {exporting ? 'Exporting...' : 'Export PDF'}
        </button>
      </div>

      <ClientView audit={audit} isInternal={true} onSaveSections={handleSaveSections} onUpdateAudit={async (updated) => {
        setAudit(updated);
        await saveAudit(updated);
      }} />
    </div>
  );
}
